export const NO_OF_BEST_CATEGORY_POSTS = 4;
export const NO_OF_CALCULATORS = 6;

export const SEO_META_NO_INDEX = [
  {
    name: "robots",
    content: "noindex,follow",
  },
];

export const SEO_MATA_INDEX = [
  {
    name: "robots",
    content: "index,follow",
  },
];
